import { render, staticRenderFns } from "./Sculptures.vue?vue&type=template&id=db910f28&scoped=true&"
import script from "./Sculptures.vue?vue&type=script&lang=js&"
export * from "./Sculptures.vue?vue&type=script&lang=js&"
import style0 from "./Sculptures.vue?vue&type=style&index=0&id=db910f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db910f28",
  null
  
)

export default component.exports